angular
  .module('vppApp')
  .directive('compareTo', function () {
    return {
      require: "ngModel",
      scope: {
        otherModelValue: "=compareTo"
      },
      link: function(scope, element, attributes, ngModel) {
        var currValue;
        ngModel.$validators.compareTo = function(modelValue) {
          return modelValue == currValue;
        };

        scope.$watch('otherModelValue', function(nVal) {
          currValue = nVal;
        });
      }
    };
  });